import { EMAIL_DOMAIN, enforcePasswordComplexity } from "@project/common";
import type { IntlShape } from "react-intl";
import { z } from "zod";
import type { ParsePayload } from "zod/v4/core";

export const emailSchema = (intl: IntlShape) => z.email(intl.formatMessage({
  id: "error.invalidEmail",
  defaultMessage: "Invalid email",
})).check((ctx: ParsePayload<string>) => {
  const { value: email } = ctx;
  if (import.meta.env.VITE_DEPLOY_ENV === "prod" || import.meta.env.VITE_DEPLOY_ENV === "local") {
    return;
  }
  if (!email.endsWith(EMAIL_DOMAIN)) {
    ctx.issues.push({
      code: "custom",
      input: email,
      message: intl.formatMessage({
        id: "error.invalidEmailTest",
        defaultMessage: "Only test emails are allowed",
      }),
      path: ["email"],
    });
  }
});

export const passwordSchemaStrength = (intl: IntlShape) => z
  .string()
  .check(
    enforcePasswordComplexity(
      intl.formatMessage({
        id: "error.passwordTooWeak",
        defaultMessage: "Password is not secure and easy to guess",
      }),
    ),
  );

export const passwordSchemaLength = (intl: IntlShape) => z
  .string()
  .min(4, intl.formatMessage({
    id: "error.passwordTooShort",
    defaultMessage: "Password need to have at least 4 characters",
  }));

export const passwordMismatch = (intl: IntlShape) =>
  intl.formatMessage({
    id: "error.passwordsMismatch",
    defaultMessage: "Passwords don't match",
  });

export const emailMismatch = (intl: IntlShape) =>
  intl.formatMessage({
    id: "error.emailMismatch",
    defaultMessage: "Emails don't match",
  });

export const nameSchema = (intl: IntlShape) => z.string().min(2, intl.formatMessage({
  id: "error.nameTooShort",
  defaultMessage: "Name need to have at least 2 characters",
}));

export const billingAddressSchemaCustom = (intl: IntlShape) => z.object({
  vat: z.string().optional(),
  type: z.enum([
    "personal",
    "business",
  ], {
    message: intl.formatMessage({
      id: "error.invalidBillingAddressType",
      defaultMessage: "Invalid billing address type",
    }),
  }),
});
